import { useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'

import { Shop } from '../types/shop'

interface usePickupProps {
	onSubmition: () => void
	shops?: Shop[]
}

export const usePickup = (props: usePickupProps) => {
	const { onSubmition, shops = [] } = props

	const searchParams = useSearchParams()
	const storeId = searchParams.get('store') as string

	const [selectedShop, setSelectedShop] = useState<Shop | null>(null)

	const handleShopSelection = (shop: Shop) => {
		setSelectedShop(shop)
	}

	const handleSubmit = () => {
		if (selectedShop) {
			onSubmition?.()
		}
	}

	const resetSelection = () => {
		setSelectedShop(null)
	}

	useEffect(() => {
		const preselectedStore = storeId ? shops.find(shop => shop.STORE_ID === storeId) : null

		if (preselectedStore) {
			setSelectedShop(preselectedStore)
		}
	}, [shops, storeId])

	return {
		selectedShop: {
			name: selectedShop?.NAME,
			storeId: selectedShop?.STORE_ID
		},
		handleShopSelection,
		handleSubmit,
		resetSelection
	}
}
